const merge = require('lodash/fp/merge');
const parseRequestMetaData = require('../utils/parse-request-meta-data');
const config = require('../config'); const apiConfig = require('../api-config');

const headers = { Accept: 'application/json' }

function parsePaymentResult(data) {
   if((!data) || data.length==0){
     return null;
    }
    else {
      return JSON.stringify(data);
    }
}

function fetchData ({ metaData }, requestHandler) {
  const meta = parseRequestMetaData(metaData);
  const request = {
    method: 'POST',
    url: `${config.baseUrl}/cash/${apiConfig.apiversion}/cash-positions-payments`,
    Accept: 'application/json',
    headers: merge(headers, meta.headers),
    body: {
      userId: meta.qs.userId,
      branchCode: meta.portfolio.branchCode,
    },
    json: true,
  }
  // serialize
  return requestHandler(request)
    .then(parsePaymentResult)
    .catch(() => null)
}

function addRoutes({ requestHandler } = {}) {
  return app => app
    .match(`[{keys:metaData}].paymentsAvailableCheck.getData`, requests => {
      return Promise.all(requests.map(
        ({ req, res }) => fetchData(req.params, requestHandler)
        .then(response => res.value(response))
      ))
    }
      
    )
}

module.exports = addRoutes